import type { FC } from 'react';
import EyeIcon from '@untitled-ui/icons-react/build/esm/Eye';
import LayoutBottomIcon from '@untitled-ui/icons-react/build/esm/LayoutBottom';
import { Box, Button, Container, Stack, SvgIcon, Typography } from '@mui/material';

// import { LogoAccenture } from 'src/components/logos/logo-accenture';
// import { LogoAtt } from 'src/components/logos/logo-att';
// import { LogoAws } from 'src/components/logos/logo-aws';
// import { LogoBolt } from 'src/components/logos/logo-bolt';
// import { LogoSamsung } from 'src/components/logos/logo-samsung';
// import { LogoVisma } from 'src/components/logos/logo-visma';
import platinx from 'src/components/logos/platinx.png';
import bybit from 'src/components/logos/bybit.png';
import stepmint from 'src/components/logos/stepmint.png';
import mrmint from 'src/components/logos/mrmint.png';
import hurupay from 'src/components/logos/hurupay.png';
import mudrex from 'src/components/logos/mudrex.png';


export const HomeHero: FC = () => {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100%',
        overflow: 'hidden',
        pt: { xs: 12, md: 0 },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'radial-gradient(circle at 30% 30%, rgba(255, 107, 0, 0.15) 0%, rgba(15, 21, 33, 0) 70%)', // Orange glow
          backgroundSize: '100% 100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          animation: 'gradientFlow 30s ease-in-out infinite alternate',
          zIndex: 0,
        },
        '@keyframes gradientFlow': {
          '0%': {
            transform: 'scale(1.0) translate(0%, 0%)',
            opacity: 0.15,
          },
          '50%': {
            transform: 'scale(1.05) translate(-0.5%, -0.5%)',
            opacity: 0.2,
          },
          '100%': {
            transform: 'scale(1.0) translate(0.5%, 0.5%)',
            opacity: 0.15,
          },
        }
      }}
    >
      {/* Orange accent lines */}
      {/* <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          width: '150px',
          height: '1px',
          backgroundColor: '#FF6B00',
          opacity: 0.5,
          zIndex: 0
        }}
      /> */}
      {/* <Box
        sx={{
          position: 'absolute',
          bottom: '15%',
          right: '5%',
          width: '150px',
          height: '1px',
          backgroundColor: '#FF6B00',
          opacity: 0.5,
          zIndex: 0
        }}
      /> */}
      {/* <Box
        sx={{
          position: 'absolute',
          top: '20%',
          right: '10%',
          width: '1px',
          height: '150px',
          backgroundColor: '#FF6B00',
          opacity: 0.5,
          zIndex: 0
        }}
      /> */}

      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          position: 'relative',
          zIndex: 1
        }}
      >
        <Box maxWidth="md"
          sx={{ textAlign: 'center', mx: 'auto' }}>
          <Typography
            variant="overline"
            color="#FF6B00" // Orange
            sx={{
              mb: 2,
              display: 'block',
              fontWeight: 600,
              letterSpacing: '0.1em',
              marginTop: "40px",
              fontSize: { xs: '0.875rem', md: '1rem' }
            }}
          >
            CRYPTO ON/OFF-RAMP FOR BUSINESSES
          </Typography>
          <Typography
            variant="h1"
            sx={{
              mb: 3,
              fontSize: { xs: '2.5rem', md: '3.75rem' },
              lineHeight: 1.2,
              fontWeight: 700,
            }}
          >
            Move <Typography
              component="span"
              color="#FF6B00" // Orange
              variant="inherit"
              sx={{ fontWeight: 700 }}
            >
              money
            </Typography> at the speed of light
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '1.125rem', md: '1.375rem' },
              fontWeight: 500,
              maxWidth: '800px',
              mx: 'auto',
              mb: 5,
              lineHeight: 1.6
            }}
          >
            Transform your business immediately. Move fiat to crypto and back instantly with seamless, low-code integration.
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              mb: 6,
              fontSize: '1.1rem',
              opacity: 0.9
            }}
          >
            Supporting 30+ countries, 400+ tokens, 20+ blockchains
          </Typography>

          <Stack
            alignItems="center"
            direction={{ xs: 'column', sm: 'row' }}
            spacing={3}
            justifyContent="center"
            sx={{ mb: 8 }}
          >
            <Button
              component="a"
              href="https://cal.com/support-team-qsszsx"
              target="_blank"
              startIcon={(
                <SvgIcon fontSize="small">
                  <EyeIcon />
                </SvgIcon>
              )}
              sx={{
                backgroundColor: '#FF6B00', // Orange
                color: '#FFFFFF',
                '&:hover': {
                  backgroundColor: '#CC5500', // Darker orange
                },
                py: 1.5,
                px: 4,
                fontSize: '1rem',
                borderRadius: 2
              }}
              variant="contained"
              size="large"
            >
              Talk to us
            </Button>
            <Button
              component="a"
              href="https://docs.swiftramp.in"
              target="_blank"
              startIcon={(
                <SvgIcon fontSize="small">
                  <LayoutBottomIcon />
                </SvgIcon>
              )}
              variant="outlined"
              size="large"
              sx={{
                py: 1.5,
                px: 4,
                fontSize: '1rem',
                borderRadius: 2,
                borderColor: 'rgba(255, 255, 255, 0.2)',
                '&:hover': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)'
                }
              }}
            >
              Read our Docs
            </Button>
          </Stack>
        </Box>
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            width: '100%'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: { xs: 4, md: 6 },
              opacity: 0.7,
              mb: { xs: 4, md: 0 }
            }}
          >
            <Stack
              justifyContent="center"
              spacing={3}
              sx={{ py: 3 }}
            >
              <Typography
                align="center"
                variant="body2"
                sx={{ fontWeight: 500, mb: 2 }}
              >
                Trusted by 100+ Businesses
              </Typography>
              <Box
                sx={{
                  position: 'relative',
                  textAlign: 'center',
                  width: '100%'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: 4,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexWrap: 'wrap'
                  }}
                >
                  {[
                    platinx,
                    bybit,
                    stepmint,
                    mrmint,
                    hurupay,
                    mudrex
                  ].map((logo, index) => (
                    <Box
                      key={index}
                      component="img"
                      src={logo}
                      alt="logo"
                      sx={{
                        height: 40, // Adjust height as needed
                        width: 'auto',
                        // filter: 'grayscale(1)', // Optional: makes logos gray
                        transition: 'all 0.2s',
                        // '&:hover': {
                        //   filter: 'grayscale(0)',
                        //   opacity: 1
                        // }
                      }}
                    />
                  ))}
                </Box>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};